export * from './form-prompt'



// WEBPACK FOOTER //
// ./src/app/shared/components/form-prompt/index.ts